import { Radio } from "antd";
import { type RadioChangeEvent, type RadioGroupProps } from "antd/lib/radio/interface";
import { memo, type ReactNode } from "react";

import { cn } from "@btnet/utilities-core";

import { type ITrackingProp, track } from "utilities/analytics/analytics";

import "commonComponents/btWrappers/BTRadioGroupDeprecated/BTRadioGroupDeprecated.less";

interface IBTRadioGroupDeprecatedProps extends RadioGroupProps {
    children?: ReactNode;
    horizontal?: boolean;
    displayBlock?: boolean;
    hasOptionDescriptions?: boolean;
    "data-testid"?: string;
}

/**
 * @deprecated Use `BTRadioGroup` from `@btnet/core-components` instead. This component is being replaced by an updated version; please migrate to `BTRadioGroup` when possible.
 */
export const BTRadioGroupDeprecated: React.FC<IBTRadioGroupDeprecatedProps & ITrackingProp> = track(
    {
        element: "Radio Group",
    },
)(
    memo(
        ({
            children,
            horizontal = false,
            displayBlock = false,
            hasOptionDescriptions = false,
            className,
            "data-testid": dataTestId,
            onChange,
            tracking,
            ...otherProps
        }) => {
            const handleChange = (e: RadioChangeEvent) => {
                // only track event if there is uniqueId
                if (tracking && dataTestId) {
                    tracking.trackEvent({
                        uniqueId: dataTestId,
                        event: "ValueChange",
                        value: e.target.value,
                    });
                }
                onChange?.(e);
            };
            return (
                // eslint-disable-next-line react/forbid-elements
                <Radio.Group
                    className={cn(className, {
                        "BTRadioGroup--Horizontal": horizontal,
                        "BTRadioGroup--DisplayBlock": displayBlock,
                        BTRadioGroup: !hasOptionDescriptions,
                        BTRadioGroupWithLabels: hasOptionDescriptions,
                    })}
                    onChange={handleChange}
                    data-testid={dataTestId}
                    {...otherProps}
                >
                    {children}
                </Radio.Group>
            );
        },
    ),
);
